import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52d7d6dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notification__title"
}
const _hoisted_2 = { class: "notification__content" }
const _hoisted_3 = {
  key: 0,
  class: "notification__description"
}
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    isOpen: _ctx.isOpen,
    onToggle: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle'))),
    width: "700px",
    height: "auto"
  }, {
    header: _withCtx(() => [
      (_ctx.notification)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.notification.title), 1))
        : _createCommentVNode("", true)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.notification)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.notification.description), 1))
          : _createCommentVNode("", true),
        (_ctx.notification.imageNotification)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.notification.imageNotification,
              alt: "Imagem da notificação",
              class: "notification__image"
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}